export const DATADOG_EXCLUDED_DOMAINS = [
  'resource.digital.voice.va.gov',
  'browser-intake-ddog-gov.com',
  'google-analytics.com',
  'eauth.va.gov',
  'api.va.gov',
];

export const DATADOG_CLICK_ACTION_NAME = 'Clicked item';

/**
 * Replace click action names with a generic label so element text containing
 * PII is never sent to Datadog RUM.
 *
 * @param {Object} event - RUM event passed to `beforeSend`
 * @returns {boolean} always `true` to keep the event
 */
export const scrubClickActionNames = event => {
  if (event?.action?.type === 'click' && event.action.target) {
    // eslint-disable-next-line no-param-reassign
    event.action.target.name = DATADOG_CLICK_ACTION_NAME;
  }
  return true;
};

/**
 * Drop RUM resource events for third-party and API domains.
 *
 * @param {Object} event - RUM event passed to `beforeSend`
 * @returns {boolean} `false` to drop the event, `true` to keep it
 */
export const dropExcludedResources = event => {
  if (event?.type !== 'resource') return true;
  const url = event.resource?.url || '';
  return !DATADOG_EXCLUDED_DOMAINS.some(domain => url.includes(domain));
};

/**
 * Shared Datadog RUM `beforeSend` hook for health apps. The platform
 * `useBrowserMonitoring` composes this with its own baseline `beforeSend`.
 *
 * @example
 * useBrowserMonitoring({ service: 'my-app', beforeSend: healthAppsBeforeSend });
 *
 * @param {Object} event - RUM event passed to `beforeSend`
 * @returns {boolean} `false` to drop the event, `true` to keep it
 */
export const healthAppsBeforeSend = event => {
  scrubClickActionNames(event);
  return dropExcludedResources(event);
};
